import { render, staticRenderFns } from "./AboutContent.vue?vue&type=template&id=b11f0c1e&scoped=true"
import script from "./AboutContent.vue?vue&type=script&lang=js"
export * from "./AboutContent.vue?vue&type=script&lang=js"
import style0 from "./AboutContent.vue?vue&type=style&index=0&id=b11f0c1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11f0c1e",
  null
  
)

export default component.exports